import styled from 'styled-components'

const ApartmentDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: ${props => (props.isGrid ? undefined : '70%')};

  @media (min-width: 992px) and (max-width: 1200px) {
    width: ${props => (props.isGrid ? undefined : '100%')};
  }
`

export default ApartmentDetailsContainer
